module.exports = __webpack_public_path__ + "img/AI (5).cb97070e.png";